export default new class SelectOffer {
  constructor() {
    this.method = 'onChangeOffer';
  }

  init(el) {
    el.addEventListener('select-change', event => this.selectCallback(event.detail));
  }

  selectCallback(event) {
    oc.ajax(this.method, {
      data: { iOfferID: event },
    });
  }
}();
